<template>
  <div class="main-layout__box">
    <template v-if="active === 'list'">
      <div
        class="main-layout__item main-layout__item_head main-layout__item_hover main-layout__item_p12"
      >
        <div class="w-3 t-c foz-23">#</div>
        <div class="w-4"></div>
        <div class="w-10">{{ $t("listsHeader.full_name") }}</div>
        <div class="w-11">{{ $t("listsHeader.phone") }}</div>
        <div class="w-11">{{ $t("listsHeader.email") }}</div>
        <div class="w-6">{{ $t("navigation.services") }}</div>
        <div class="w-6 main-flex">
          {{ $t("listsHeader.rate") }}
          <div class="main-layout__sort-box">
            <sort-svg
              @onClick="sort('rating', 'asc')"
              ref="rating_asc"
              class="sort-svg sort-svg_up"
            />

            <sort-svg @onClick="sort('rating', 'desc')" ref="rating_desc" class="sort-svg" />
          </div>
        </div>
        <div class="w-6 main-flex">
          {{ $t("listsHeader.orders") }}
          <div class="main-layout__sort-box">
            <sort-svg
              @onClick="sort('qtyOrders', 'asc')"
              ref="qtyOrders_asc"
              class="sort-svg sort-svg_up"
            />

            <sort-svg @onClick="sort('qtyOrders', 'desc')" ref="qtyOrders_desc" class="sort-svg" />
          </div>
        </div>
        <div class="w-8 main-flex">
          {{ $t("listsHeader.busy") }}
          <div class="main-layout__sort-box">
            <sort-svg
              @onClick="sort('isBusy', 'asc')"
              ref="isBusy_asc"
              class="sort-svg sort-svg_up"
            />

            <sort-svg @onClick="sort('isBusy', 'desc')" ref="isBusy_desc" class="sort-svg" />
          </div>
        </div>
        <div class="main-layout__item-actions">{{ $t("listsHeader.actions") }}</div>
      </div>

      <transition-group name="list" tag="div" class="main-layout__list main-layout__list_mxh87">
        <div
          class="main-layout__item main-layout__item_hover"
          v-for="(user, index) in usersData"
          :key="user.id"
          :class="{
            delete: user.deletion_tag,
            inactive: user.is_inactive
          }"
        >
          <div class="w-3 t-c">{{ index + 1 }}</div>

          <div class="w-4">
            <img class="radius-50" width="24px" height="24px" :src="getImage(user.small_image)" alt />
          </div>
          <div class="w-10" :title="user.first_name + ' ' + user.last_name">
            <span>{{ user.first_name }} {{ user.last_name }}</span>
          </div>
          <div class="w-11" :title="user.phone">
            <span>{{ user.phone }}</span>
          </div>
          <div class="w-11" :title="user.email">
            <span>{{ user.email }}</span>
          </div>
          <!-- <div class="userlist__item-partner row-w9">
                    <span v-if="user.partner !== null">{{
                      user.partner.name
                    }}</span>
                    <span v-else>{{ partnerName }}</span>
          </div>-->
          <div class="w-6">
            <span>{{ user.service.title }}</span>
          </div>
          <div class="w-6" :title="user.rate">
            <span>{{ Math.round(user.rating * 100) / 100 }}</span>
          </div>
          <div class="w-6" :title="user.qty_requests">
            <span>{{ user.qty_requests }}</span>
          </div>
          <div class="w-8" :class="{ 'userlist__item-status--busy': user.is_busy }"></div>
          <!-- <div class="userlist__item-current-status row-w10">
                    {{ localeOrderStatus(user.status) }}
          </div>-->
          <div class="main-layout__item-actions">
            <div>
              <router-link
                :to="{
                  name: 'master-calendar',
                  params: { employee_id: user.id, type },
                  query: { master: user.id },
                }"
              >
                <svg class="main-layout__item-icon">
                  <use xlink:href="/images/svg/symbols.svg#svg-user-calendar" />
                </svg>
              </router-link>
            </div>
            <div v-if="$guard('read', 'Chat')" @click="openChat(user.id)">
              <svg
                class="main-layout__item-icon"
                id="open-chat"
                viewBox="-21 -47 682.66669 682"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill="var(--bg-color-green)"
                  d="m552.011719-1.332031h-464.023438c-48.515625 0-87.988281 39.464843-87.988281
                   87.988281v283.972656c0 48.414063 39.300781 87.816406 87.675781
                    87.988282v128.863281l185.191407-128.863281h279.144531c48.515625
                     0 87.988281-39.472657
                      87.988281-87.988282v-283.972656c0-48.523438-39.472656-87.988281-87.988281-87.988281zm50.488281
                       371.960937c0 27.835938-22.648438 50.488282-50.488281 50.488282h-290.910157l-135.925781
                        94.585937v-94.585937h-37.1875c-27.839843
                         0-50.488281-22.652344-50.488281-50.488282v-283.972656c0-27.84375 22.648438-50.488281
                          50.488281-50.488281h464.023438c27.839843 0 50.488281 22.644531 50.488281 50.488281zm0 0"
                />
                <path
                  fill="var(--bg-color-green)"
                  d="m171.292969 131.171875h297.414062v37.5h-297.414062zm0 0"
                />
                <path
                  fill="var(--bg-color-green)"
                  d="m171.292969 211.171875h297.414062v37.5h-297.414062zm0 0"
                />
                <path
                  fill="var(--bg-color-green)"
                  d="m171.292969 291.171875h297.414062v37.5h-297.414062zm0 0"
                />
              </svg>
            </div>

            <call-btn :user="user" type="masters" />

            <div @click="openEditModal(user.id)">
              <svg class="main-layout__item-icon">
                <use xlink:href="/images/svg/symbols.svg#svg-user-message" />
              </svg>
            </div>

            <div>
              <svg
                @click="openMasterSchedule(user.id)"
                class="main-layout__item-icon"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.9499 18.9999H2.05C1.45 18.9999 1 18.5499 1 17.9499V2.05C1 1.45 1.45 1
                   2.05 1H17.8749C18.4749 1 18.9249 1.45 18.9249 2.05V17.8749C18.9999 18.5499
                    18.5499 18.9999 17.9499 18.9999Z"
                  stroke="#9BCD82"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M6.99997 6.99997H1V2.05C1 1.45 1.45 1 2.05 1H6.99997V6.99997Z"
                  stroke="#9BCD82"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12.9999 1H6.99994V6.99997H12.9999V1Z"
                  stroke="#9BCD82"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M19 6.99997H13V1H17.95C18.55 1 19 1.45 19 2.05V6.99997Z"
                  stroke="#9BCD82"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M6.99997 6.99976H1V12.9997H6.99997V6.99976Z"
                  stroke="#9BCD82"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12.9999 6.99976H6.99994V12.9997H12.9999V6.99976Z"
                  stroke="#9BCD82"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M19 6.99976H13V12.9997H19V6.99976Z"
                  stroke="#9BCD82"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M6.99997 19H2.05C1.45 19 1 18.55 1 17.95V13H6.99997V19Z"
                  stroke="#9BCD82"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12.9999 13H6.99994V19H12.9999V13Z"
                  stroke="#9BCD82"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M17.95 19H13V13H19V17.95C19 18.55 18.55 19 17.95 19Z"
                  stroke="#9BCD82"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8.79999 8.80005L11.2 11.2"
                  stroke="#9BCD82"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.2 8.80005L8.79999 11.2"
                  stroke="#9BCD82"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M2.79999 14.7998L5.19998 17.1998"
                  stroke="#9BCD82"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M5.19998 14.7998L2.79999 17.1998"
                  stroke="#9BCD82"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M14.7999 8.80005L17.1999 11.2"
                  stroke="#9BCD82"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M17.1999 8.80005L14.7999 11.2"
                  stroke="#9BCD82"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>

            <div v-if="role !== 'partner-admin'" @click="deleteOpen({ user })">
              <svg class="main-layout__item-icon">
                <use xlink:href="/images/svg/symbols.svg#svg-user-del" />
              </svg>
            </div>

            <div>
              <delete-request
                v-if="$guard('delete', toCapitilize(type)) && user.deletion_tag"
                :item="user"
                :type="type"
                @save="fetchMasters"
                @remove="deleteOpenAdapter"
              />
            </div>
          </div>
        </div>
      </transition-group>

      <add-btn v-if="$guard('write', toCapitilize(type))" @onClick="addOpen" />
    </template>

    <div class="main-layout__map main-layout__map_absolute" style="height: 92vh" v-else>
      <MapEmployee
        :updated="usersData"
        @openEditModal="openEditModal"
        @deleteOpen="deleteOpenAdapter"
        :typeMap="type"
      />
    </div>

    <modal
      :show="specialistModal"
      @close="toggleSpecialistModalAdapter"
      :outside="false"
      :dark="true"
    >
      <transition name="showmodal">
        <employee
          v-if="specialistModal"
          :typeAction="typeAction"
          :typeEmployee="typeEmployee"
          :request="request"
          :services="services"
          :type="type"
          :changeView="changeView"
          :newDataEmployee="newUserData"
          @cancelAction="toggleSpecialistModalAdapter"
          @okAction="empoloyeeConfirm"
          @setAvatar="setAvatarConfirm"
          @updateAvatar="updateAvatarConfirm"
        ></employee>
      </transition>
    </modal>

    <modal
      :show="showModalDelete"
      :showBtn="false"
      :dark="true"
      :outside="false"
      @close="closeModal"
    >
      <delete-modal
        :title="$t('lists.deleteCompanyEmployeeMess').toString()"
        :cancelDeletionTag="
          deletionStatusGetters && !$guard('write', toCapitilize(type))
        "
        @cancel="closeModal"
        @next="removeAction"
      />
    </modal>
  </div>
</template>

<script>
import locale from '@/utils/locale'
import MapEmployee from '@/components/controls/map-employee.vue'
import { mapGetters, mapMutations } from 'vuex'
import deleteRequest from '@/components/controls/deleteRequest'
import sort from '@/mixins/sort'
import callBtn from '@/components/lists/clients/clientsCallBtn/index'
import sortSvg from '@/components/controls/sortSvg'
import addBtn from '@/components/controls/addBtn'
import debounce from '@/utils/debounce'

export default {
    components: {
        MapEmployee,
        deleteRequest,
        callBtn,
        sortSvg,
        addBtn,
    },
    props: [
        'active',
        'type',
        'usersData',
        'userData',
        'addEmployee',
        'editEmployee',
        'deleteEmployee',
        'getEmployee',
        'services',
        'newUserData',
        'setAvatar',
        'updateAvatar',
        'request',
        'newEmplooyeeTitle',
        'addEmployeeTitle',
        'changeView',
    ],
    mixins: [locale, sort],
    data() {
        return {
            showModalEmployee: false,
            showModalDelete: false,
            // showModalCall: false,
            typeAction: '',
            typeEmployee: '',
            id: '',
            defaultImage: '/images/default-user.svg',
            role: window.$role,
        }
    },
    computed: {
        ...mapGetters({
            specialistModal: 'specialists/gettersSpecialistModal',
            deletionStatusGetters: 'specialists/deletionStatusGetters',
        }),
        partnerName() {
            return this.$config.behavior === 'hilfy' ? 'Hilfy' : 'Profy'
        },
    },
    methods: {
        ...mapMutations({
            toggleSpecialistModal: 'specialists/setSpecialistModal',
            setDeletionStatus: 'specialists/setDeletionStatus',
            setSort: 'specialists/setSort',
            setStateSpecialist: 'specialists/setState',
            clearNewForm: 'specialists/clearNewForm',
            setState: 'sip/setState',
        }),
        openEditModal: debounce(function fn(id) {
            this.typeAction = 'edit'
            this.id = id
            this.$emit('getEmployee', id)
        }, 2000),
        openMasterSchedule(data) {
            this.setStateSpecialist({
                type: 'scheduleMasterId',
                data,
            })

            this.setStateSpecialist({
                type: 'isActive',
                data: 'schedule',
            })
        },
        toggleSpecialistModalAdapter() {
            this.toggleSpecialistModal()

            if (!this.specialistModal) {
                this.clearNewForm()
            }
        },
        toCapitilize(v) {
            const word = v.split('')
            word[0] = word[0].toUpperCase()
            return word.join('')
        },
        closeModal() {
            this.showModalEmployee = false
            this.showModalDelete = false
            // this.showModalCall = false;
        },
        addOpen() {
            this.toggleSpecialistModal()
            this.typeAction = 'add'
            this.typeEmployee = this.newEmplooyeeTitle
        },
        empoloyeeConfirm(cb) {
            if (this.typeAction === 'add') {
                this.$emit('addEmployee', cb)
            } else {
                this.$emit('editEmployee', this.id)
            }
        },
        deleteOpenAdapter(id) {
            this.deleteOpen({
                user: {
                    id,
                    deletion_tag: false,
                },
            })
        },

        deleteOpen({ user: { deletion_tag, id } }) {
            this.setDeletionStatus(deletion_tag)
            this.showModalDelete = true
            this.id = id
        },
        removeAction() {
            this.showModalDelete = false
            this.$emit('deleteEmployee', this.id)
        },
        setAvatarConfirm(data, type) {
            this.$emit('setAvatar', data, type)
        },
        updateAvatarConfirm(id, data) {
            this.$emit('updateAvatar', id, data)
        },
        openChat(id) {
            this.$router.push({ name: 'chat', params: { id, type: this.type } })
        },
        getImage(image) {
            return image === null ? this.defaultImage : image
        },
        async fetchMasters() {
            await this.$store.dispatch('specialists/getSpecialistsData', {
                type: this.type,
            })
        },
        async sort(orderBy, sortBy) {
            const isChanged = this.markSvgsComponents(`${orderBy}_${sortBy}`)

            this.setSort({
                sortBy: isChanged ? `&sortedBy=${sortBy}` : '',
                orderBy: isChanged ? `&orderBy=${orderBy}` : '',
            })

            await this.$store.dispatch('specialists/getSpecialistsData', {
                type: this.type,
            })
        },
    },
    beforeDestroy() {
        if (this.specialistModal) {
            this.toggleSpecialistModal()
            this.clearNewForm()
        }
    },
}
</script>

<style lang="scss" scoped>
@import "src/assets/sass/main";

.userlist__block_height {
  height: 95% !important;
}

// .userlist {
//   border-radius: 8px;
//   background-color: #ffffff;
//   width: 100%;
//   height: calc(100% - 86px);
//   position: absolute;
//   top: 0;
//   left: 0;

//   &_shadow {
//     box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
//   }

//   &__wrapper {
//     width: 100%;
//     height: 100%;
//     overflow-y: auto;
//     padding-bottom: 24px;
//     box-sizing: border-box;
//   }

// &__add {
//   position: fixed;
//   right: 25px;
//   bottom: 25px;
//   display: flex;
//   align-items: flex-end;

//   &-text {
//     color: #4d4d4d;
//     font-size: 12px;
//     margin-right: 16px;
//     font-family: $fontMedium;
//   }

//   &-button {
//     width: 56px;
//     height: 56px;
//     border-radius: 50%;
//     background-color: $primaryColor;
//     box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
//     background-image: url("/images/icon/add.svg");
//     background-position: center;
//     background-size: 20px;
//     background-repeat: no-repeat;
//     transition: 0.5s;
//     cursor: pointer;

//     &:hover {
//       background-color: $secondColor;
//     }
//   }
//   }

//   &__block {
//     display: flex;
//     position: relative;
//     &-text {
//       position: absolute;
//       left: 0;
//       top: 0;
//       width: 64px;
//       flex-shrink: 0;
//       font-family: $fontLight;
//       font-size: 30px;
//       color: #e0e0e0;
//       text-align: center;
//       text-transform: uppercase;
//       height: 100%;
//       display: flex;
//       align-items: center;
//       justify-content: center;
//     }
//   }

//   &__items {
//     width: 100%;
//     display: flex;
//     flex-direction: column;
//     // overflow-y: auto;
//     // padding-bottom: 24px;
//   }

//   &__item {
//     position: relative;
//     display: flex;
//     align-items: center;
//     height: 52px;
//     width: 100%;

//     transition: 0.5s;
//     padding-left: 64px;
//     box-sizing: border-box;

//     &:hover {
//       background-color: rgba(#71bd4a, 0.15);

//       & .userlist__item-button {
//         opacity: 1;
//       }
//     }

//     &_head {
//       color: #4d4d4d;
//       font-size: 13px;
//       font-family: $fontBold;

//       * {
//         font-size: 13px !important;
//       }
//     }

//     &-img {
//       width: 36px;
//       height: 36px;
//       background-position: center;
//       background-size: cover;
//       border: 1px solid $secondColor;
//       border-radius: 50%;
//       margin-right: 16px;
//       margin-left: 5px;

//       &_head {
//         width: 36px;
//         border: none;
//         display: flex;
//         align-items: center;
//         justify-content: center;
//         height: 100%;
//         font-size: 16px;
//       }
//     }

//     &-name {
//       font-size: 16px;
//       color: #4d4d4d;
//       font-family: $fontBold;

//       width: 10%;
//       padding-left: 1px;
//       padding-right: 1px;
//       white-space: nowrap;
//       overflow: hidden;
//       text-overflow: ellipsis;
//     }

//     &-post {
//       font-size: 12px;
//       color: #4d4d4d;

//       width: 12%;
//       padding-left: 1px;
//       padding-right: 1px;
//       white-space: nowrap;
//       overflow: hidden;
//       text-overflow: ellipsis;
//     }

//     &-phone {
//       font-size: 16px;
//       color: #4d4d4d;

//       width: 10%;
//       padding-left: 1px;
//       padding-right: 1px;
//       white-space: nowrap;
//       overflow: hidden;
//       text-overflow: ellipsis;
//     }

//     &-mail {
//       font-size: 16px;
//       color: #4d4d4d;

//       width: 15.5%;
//       padding-left: 1px;
//       padding-right: 1px;
//       white-space: nowrap;
//       overflow: hidden;
//       text-overflow: ellipsis;
//     }

// &-partner {
//   width: 8%;
// }

//     &-text {
//       width: 6%;
//     }

// &-current-status {
//   width: 6%;
//   text-align: left;
//   padding-left: 1%;
//   margin-left: 3.5%;
// }

// &-orders {
//   width: 5%;
// }

//     &-status {
//       width: 10px;
//       height: 10px;
//       border-radius: 50%;
//       background-color: $primaryColor;
//       margin-left: 23px;
//       margin-right: 23px;

//       &--busy {
//         background-color: $secondColor;
//       }

//       &_head {
//         height: unset;
//         background-color: transparent;
//       }
//     }

//     &-buttons {
//       display: flex;
//       align-items: center;
//       flex-grow: 3;
//     }

//     &-button {
//       margin-right: 16px;
//       cursor: pointer;

//       & .icon {
//         width: 30px;
//         height: 30px;
//         transition: 0.5s;

//         &:hover {
//           transform: scale(1.2);
//         }
//       }
//     }
//   }

//   &-head {
//     display: flex;
//     align-items: center;
//     font-size: 16px;
//     color: #4d4d4d;
//     padding: 5px 0;
//     font-family: "SFUIDisplay-Bold";
//     background-color: #fff;
//     z-index: 2;
//     width: 100%;
//     max-width: 100%;

//     &__id {
//       color: #e0e0e0;
//       display: flex;
//       align-items: center;
//       justify-content: center;
//       width: 64px;
//       font-size: 30px;
//       font-family: "SFUIDisplay-Regular";
//     }

//     &__image {
//       width: 60px;
//     }

//     &__name {
//       width: 12.6%;
//     }

//     &__serviceName {
//       width: 12%;
//     }

//     &__phone {
//       width: 13.5%;
//     }

//     &__mail {
//       width: 18%;
//     }

//     &__rate {
//       width: 3.5%;
//     }

//     &__status {
//       width: 3%;
//     }

//     &__current-status {
//       width: 4%;
//     }

//     &__orders {
//       width: 4%;
//     }
//   }
// }

.list-enter-active {
  transition: all 0.5s;
}

.list-leave-active {
  transition: all 0.5s;
  position: absolute;
  // transform: translateY(-30px);
}

.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

.flexbox {
  display: flex;
  align-items: center;

  div {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-left: 5px;

    img {
      cursor: pointer;
    }
  }
}
</style>
